<script setup>
import { useLayout } from '@/layout/composables/layout';
import { RouterHelpers } from '@/router/routeHelpers';
import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import AppMenu from './AppMenu.vue';

const { layoutState, toggleMenu } = useLayout();
const router = useRouter();

// Ensure menu is never collapsed in mobile mode
const handleResize = () => {
    if (window.innerWidth <= 991 && layoutState.menuCollapsed) {
        // In mobile mode, menu should never be collapsed
        layoutState.menuCollapsed = false;
    }
};

onMounted(() => {
    window.addEventListener('resize', handleResize);
    // Initial check
    handleResize();
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

const navigateToDashboard = () => {
    router.push(RouterHelpers.toDashboard());

    if (layoutState.staticMenuMobileActive || layoutState.overlayMenuActive) {
        toggleMenu();
    }
};
</script>

<template>
    <div class="layout-sidebar print:!hidden" :class="{ 'sidebar-collapsed': layoutState.menuCollapsed, 'mobile-sidebar': true }">
        <div class="sidebar-header">
            <div class="sidebar-logo">
                <a href="#" class="sidebar-logo-link" @click.prevent="navigateToDashboard">
                    <img src="/images/my-bav.svg" alt="myBAV" />
                    <span v-show="!layoutState.menuCollapsed">myBAV</span>
                </a>
            </div>
        </div>
        <div class="sidebar-content">
            <app-menu></app-menu>
        </div>
    </div>
</template>
